import React from "react";
import { site } from "../generated/content";
import { useLanguage } from "../context/LanguageContext";
import "../style/Services.css";

/**
 * Sits directly under the hero, before the longer About text. A visitor who
 * has just seen one large photograph is asking "what do these people do";
 * a scannable list answers that faster than a paragraph does.
 */
export default function Services() {
  const { lang } = useLanguage();
  const items = site.services[lang]?.length ? site.services[lang] : site.services.tr;

  if (!items || items.length === 0) return null;

  return (
    <section className="services" aria-label={lang === "en" ? "Services" : "Hizmetler"}>
      <ul className="services__list">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </section>
  );
}
